import { EventEmitter } from 'events';

const WINDOW_SIZE_MS = 250;

export default class PeakProgrammeMeter extends EventEmitter {
    constructor(config = {
        audioContext: null,
        mediaStream: null,
        windowSizeMs: WINDOW_SIZE_MS
    }) {
        super();

        this.audioContext = config.audioContext;
        this.mediaStream = config.mediaStream;
        this.windowSizeMs = config.windowSizeMs || WINDOW_SIZE_MS;

        this.sourceNode = null;
        this.processNode = null;

        this._initialiseProcessing();
    }

    destroy() {
        this._disconnectNodes();
        this.sourceNode = null;
        this.processNode = null;
        this.mediaStream = null;
        this.audioContext = null;
        this.maxValue = null;
    }

    updateMediaStream(mediaStream) {
        this.mediaStream = mediaStream;
        this._disconnectNodes();
        this._initialiseProcessing();
    }

    _disconnectNodes() {
        if (this.processNode) this.processNode.disconnect(this.audioContext.destination);
        if (this.sourceNode) this.sourceNode.disconnect(this.processNode);
    }

    _initialiseProcessing() {
        if (!(this.mediaStream instanceof MediaStream)) {
            //console.log('not a media stream');
            return;
        }

        if (this.mediaStream.getAudioTracks().length < 1) {
            //console.log('no audio tracks');
            return;
        }

        this.channels = this.mediaStream.getAudioTracks()[0].getSettings().channelCount || 2;
        this.sampleRate = this.audioContext.sampleRate;
        this.sampleWindow = ((this.sampleRate / 1000) * this.windowSizeMs) * this.channels;
        this.maxValue = [this.channels];
        this._resetValues();

        this.sourceNode = this.audioContext.createMediaStreamSource(this.mediaStream);
        this.channels = this.sourceNode.channelCount;

        this.processNode = this.audioContext.createScriptProcessor(2048, this.channels, this.channels);

        this.sourceNode.connect(this.processNode);
        this.processNode.connect(this.audioContext.destination);

        this.processNode.onaudioprocess = this._processAudio.bind(this);
    }

    _processAudio(audioProcessingEvent) {
        let inputBuffer = audioProcessingEvent.inputBuffer;
        let channel;
        let channelData = [];

        for (channel = 0; channel < this.channels; channel++) {
            channelData[channel] = inputBuffer.getChannelData(channel);
            channelData[channel].forEach(sample => {
                this.maxValue[channel] = Math.max(this.maxValue[channel], sample);

                this.currentSampleInWindow++;
                if (this.currentSampleInWindow === this.sampleWindow) {
                    let max = this.maxValue.reduce((a,b) => (a+b)) / this.maxValue.length;
                    let db = this._convertFloatToDb(max);
                    this.emit('tick', {
                        max,
                        db
                    });

                    this._resetValues();
                }
            });
        }
    }

    _convertFloatToDb(val) {
        if (val === 0.0) return -144;
        return 20.0 * Math.log10(val);
    }

    _resetValues() {
        this.currentSampleInWindow = 0;
        this.maxValue.fill(0);
    }
}
